import { render, staticRenderFns } from "./mandatory-details.vue?vue&type=template&id=c2dd280e&scoped=true"
import script from "./mandatory-details.vue?vue&type=script&lang=js"
export * from "./mandatory-details.vue?vue&type=script&lang=js"
import style0 from "./mandatory-details.vue?vue&type=style&index=0&id=c2dd280e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dd280e",
  null
  
)

export default component.exports